import routeUtils from 'app/shared/utils/routeUtils';
import pathsManifest from 'app/shared/utils/pathsManifest';

interface GetPageNameParams {
  pathname?: string;
  areaType?: string;
}

export function getPageName({ pathname = '', areaType = '' }: GetPageNameParams): string {
  let pageName = pathname;

  if (routeUtils.isPadUrl(pathname)) {
    pageName = 'MapHdpCombo';
  } else if (routeUtils.isBuildingUrl(pathname)) {
    pageName = 'MapHdpCombo';
  } else if (routeUtils.isAreaUrl(pathname)) {
    pageName = 'RentMapSearchPage-' + areaType;
  }

  for (const key in pathsManifest) {
    if (
      pathsManifest[key as keyof typeof pathsManifest] &&
      pathsManifest[key as keyof typeof pathsManifest] === pathname
    ) {
      pageName = key;
      break;
    }
  }

  return pageName;
}
